import { handleActions } from 'redux-actions';
import http from '../shared/http';
import intl from '../shared/intl';
import endpoints from '../../config/endpoints';
import cloneDeep from 'lodash/cloneDeep';
import includes from 'lodash/includes';
import sortBy from 'lodash/sortBy';
import values from 'lodash/values';
import some from 'lodash/some';
import get from 'lodash/get';
import { browserHistory } from 'react-router';
import { replace } from 'react-router-redux';

import moment from 'moment';
import qs from 'qs';
import 'moment-timezone';

import { enum as utmTags } from '../../../../enums/utm-tags';

import { actions as SmartNotificationActions } from '../smart-notification';

import { create as createPolling } from '../../../shared/js/intervals';

import socket from './socket';
import {getCookie} from '../../../shared/js/cookie';

const threadsPolling = createPolling('root', {
	fetchUpdates: { interval: 60000 }
});

const isRocket = process.env.CPA_ENV === 'rocket';

// actions types
const FETCH_APP_DATA_SUCCESS = 'root/fetch-app-data-success';
const FETCH_APP_DATA_ERROR = 'root/fetch-app-data-error';

const FETCH_UPDATES_DATA_SUCCESS = 'root/fetch-updates-data-success';
const FETCH_UPDATES_DATA_ERROR = 'root/fetch-updates-data-error';

const FETCH_APP_CONFIG = 'root/fetch-app-config';
const FETCH_CONTEST_LEADS = 'root/fetch-contest-leads';
const FETCH_CONTEST_LEADS_ERROR = 'root/fetch-contest-leads-error';

const LOGIN_USER_SUCCESS = 'root/login-user-success';
const LOGIN_USER_ERROR = 'root/login-user-error';
const LOGOUT_USER_SUCCESS = 'root/logout-user-success';
const LOGOUT_USER_ERROR = 'root/logout-user-error';
const TOGGLE_REGISTER = 'root/toggle-register';
const REGISTER_SUCCESS = 'root/register-success';
const REGISTER_ERROR = 'root/register-error';

export const REFETCH_ALL_DATA = 'root/refetch-reload';

const LOGIN_WITH_ADMIN_SUCCESS = 'root/login-with-admin-success';
const LOGIN_WITH_ADMIN_ERROR = 'root/login-with-admin-error';
const SPINNER_TOGGLE = 'root/spinner-toggle';
const SAVE_VIEWED_POPUPS_SUCCESS = 'root/save-viewed-popups-success';
const SAVE_VIEWED_POPUPS_FAILURE = 'root/save-viewed-popups-failure';
const CLOSE_POPUP = 'root/close-popup';

function storageChanged (e, dispatch, email) {
	var data = window.localStorage.getItem('crossTabUserEmail');
	if (data != email) {
		window.location.reload(true);
	}
}

// initial state
const initialState = {
	userData: null,
	shouldLogin: null,
	shouldRegister: false,
	shouldShowLoadingSpinner: false,
	popup: null,
	lists: null,
	error: false
};

// actions
export const actions = {
	fetchAppData: (lang) => (dispatch, getState) => {
		const langString = lang ? `?lang=${lang}` : '';

		const urls = [
			`${endpoints.LISTS.ALL}/global-config`,
			`${endpoints.PROFILE.MAIN}`,
			`${endpoints.PROFILE.BALANCES}`,
			`${endpoints.LISTS.ALL}${langString}`,
			`${endpoints.TICKETS.ALL}/new-posts`
		];

		if (isRocket && popup.shouldBeShown()) {
			urls.push(endpoints.CUSTOM_POPUPS.BASE);
		}

		const request = http({
			url: urls,
			method: 'get',
			actions: [
				FETCH_APP_DATA_SUCCESS,
				FETCH_APP_DATA_ERROR
			]
		});
		return request(dispatch).then(async action => {
			if (action.type === FETCH_APP_DATA_SUCCESS) {

				if (window.globalConfig.appDomainNew && getCookie('was_last_on_new') === 'true') {
					document.location.href = `//${window.globalConfig.appDomainNew}`;
				}
				const affiliate = action.payload[1].data;

				if (!affiliate.is_from_admin) {
					socket.emit('online', affiliate.id);
				}

				window.localStorage.setItem('crossTabUserEmail', affiliate.email);
				window.addEventListener('storage', e => {
					storageChanged(e, dispatch, affiliate.email);
				});
				setTimeout(() => SmartNotificationActions.fetchData()(dispatch, getState), 1000);
				threadsPolling.actions.start('root', 'fetchUpdates', actions.fetchUpdates(), dispatch);

				if (process.env.CPA_ENV === 'everad') {
					if (process.env.NODE_ENV === 'production') {
						Rollbar && Rollbar.configure({
							payload: { person: { id: affiliate.id } }
						});
					}
					await dispatch(actions.fetchContestConfig());
					dispatch(actions.fetchConversionsCount());
				}

				// add lang class to body
				document.body.className = `is-lang-${affiliate.language}`;
				// trackJs.configure({
				// 	userId: affiliate.id.toString()
				// });
				// trackJs.addMetadata('email', affiliate.email);

				const link = window.location.href;

				if (some(values(utmTags), tag => includes(link, tag))) {
					dispatch(replace(omitQueryParams(link, values(utmTags))));

					http({
						url: endpoints.PROFILE.VISIT_DASHBOARD,
						method: 'post',
						actions: [],
						data: { link, referer: document.referrer }
					})(dispatch);
				}
			}
		});
	},

	fetchUpdates: () => dispatch => {
		const request = http({
			url: [`${endpoints.TICKETS.ALL}/new-posts`, `${endpoints.PROFILE.BALANCES}`, `${endpoints.PROFILE.MAIN}`],
			method: 'get',
			actions: [
				FETCH_UPDATES_DATA_SUCCESS,
				FETCH_UPDATES_DATA_ERROR //action is not handled, because it's not important
			]
		});

		request(dispatch)
			.then(res => {
				if (process.env.CPA_ENV === 'rocket' && get(res, 'payload[2].data.is_need_notify')) {
					browserHistory.push('ranks/');
				}
			});
	},

	fetchContestConfig: () => dispatch => {
		return http({
			url: endpoints.PROFILE.APP_CONFIG,
			method: 'get',
			actions: [ FETCH_APP_CONFIG ]
		})(dispatch);
	},

	fetchConversionsCount: () => (dispatch, getState) => {
		const contestConfig = selectors.getContestConfig(getState());
		if (!contestConfig || !contestConfig.startBaner2 || !contestConfig.endBaner2) {
			return;
		}
		const query = {
			timezone: contestConfig.timezone || 'Europe/Kiev',
			status: contestConfig.status || 'approved',
			date_range: {
				start: contestConfig.startBaner2,
				end: contestConfig.endBaner2
			}
		};

		return http({
			url: `${endpoints.STATISTICS.CONVERSIONS_COUNT}?${qs.stringify(query)}`,
			method: 'get',
			actions: [ FETCH_CONTEST_LEADS, FETCH_CONTEST_LEADS_ERROR ]
		})(dispatch);
	},

	login: (data) => dispatch => {
		const request = http({
			url: endpoints.APP.SESSION,
			method: 'put',
			actions: [
				LOGIN_USER_SUCCESS,
				LOGIN_USER_ERROR
			],
			data
		});
		dispatch(request);
	},

	toggleRegister: () => dispatch => dispatch({
		type: TOGGLE_REGISTER
	}),

	register: formData => dispatch => {
		(http({
			url: endpoints.APP.SESSION,
			method: 'post',
			actions: [
				REGISTER_SUCCESS,
				REGISTER_ERROR
			],
			data: { ...formData, language: 'ru' }
		}))(dispatch);
	},

	logout: () => dispatch => {
		(http({
			url: endpoints.APP.SESSION,
			method: 'delete',
			actions: [
				LOGOUT_USER_SUCCESS,
				LOGOUT_USER_ERROR
			]
		}))(dispatch).then(payload => {
			// trackJs.configure({userId: ''});
			// trackJs.removeMetadata('email');
			return payload;
		});
	},

	saveInLocalStorage: (key, value) => dispatch => {
		window.localStorage.setItem(key, value);
		dispatch(actions.refetchAll());
	},

	refetchAll: () => dispatch => {
		dispatch({type: REFETCH_ALL_DATA});
	},

	loginWithAdmin: pathname => dispatch => {
		const request = http({
			url: endpoints.APP.LOGIN_WITH_ADMIN,
			method: 'post',
			actions: [
				LOGIN_WITH_ADMIN_SUCCESS,
				LOGIN_WITH_ADMIN_ERROR
			],
			data: { pathname }
		});
		request(dispatch).then(action => {
			if (action.type === LOGIN_WITH_ADMIN_SUCCESS) {
				window.location.replace(action.payload.data.url);
			}
		});
	},

	spinnerToggle: () => ({
		type: SPINNER_TOGGLE
	}),

	closePopup: (popup_id, { is_clicked, payload }) => (dispatch, getState) => {
		if (!getState().app.userData.general.is_from_admin) {
			const request = http({
				url: endpoints.CUSTOM_POPUPS.SAVE_VIEWED,
				method: 'post',
				actions: [
					SAVE_VIEWED_POPUPS_SUCCESS,
					SAVE_VIEWED_POPUPS_FAILURE
				],
				data: { popup_id, is_clicked, payload }
			});

			request(dispatch).then((action) => {
				if (action.type === SAVE_VIEWED_POPUPS_SUCCESS) {
					popup.updateLastShowDate();
				}
			});
		}

		dispatch({ type: CLOSE_POPUP });
	}
};

// reducers
export default handleActions({
	[FETCH_APP_DATA_SUCCESS]: (state, action) => {
		const [
			{ appVariables, contest }, general, balances, lists, newPosts, popup
		] = action.payload.map(res => res.data);
		window.globalConfig = appVariables;
		window.contestConfig = contest;

		moment.tz.setDefault(general.timezone);
		return {
			...state,
			userData: {
				general,
				balances,
				activeBalance: getActiveBalance(general, balances),
				unreadMsgs: parseInt(newPosts.new_posts) || 0
			},
			popup,
			lists
		};
	},
	[FETCH_APP_DATA_ERROR]: (state, action) => {
		const status = get(action, 'payload.response.status');
		const message = get(action, 'payload.response.data.message');
		const isDeactivated = message === 'affiliate was deactivated';
		if (status === 403) {
			if (process.env.CPA_ENV==='everad') {
				window.location.href = `https://everad.com?${qs.stringify({
					'is-deactivated': isDeactivated
				})}`;

				return;
			}
			if (process.env.CPA_ENV==='rocket') {
				const landing = 'https://site.cpa-2.getship.today?';

				window.location.href = landing + qs.stringify({
					link: window.location.href,
					referer: document.referrer
				});
			}

			return { ...state, shouldLogin: true };
		}
		return { ...state, error: true };
	},
	[FETCH_CONTEST_LEADS]: (state, action) => {
		return {
			...state,
			userData: {
				...state.userData,
				friday_conversions_count: Number(action.payload.data.conversions_count)
			}
		};
	},
	[FETCH_APP_CONFIG]: (state, action) => {
		return {
			...state,
			config: action.payload.data.config,
			userData: {
				...state.userData,
				contestConfig: action.payload.data.config
			}
		};
	},
	[FETCH_UPDATES_DATA_SUCCESS]: (state, action) => {
		const [ newPosts, balances, general ] = action.payload.map(res => res.data);
		return {
			...state,
			userData: {
				...state.userData,
				general,
				balances,
				unreadMsgs: parseInt(newPosts.new_posts) || 0
			}
		};
	},
	[FETCH_UPDATES_DATA_ERROR]: (state) => {
		threadsPolling.actions.stop('root', 'fetchUpdates');
		return state;
	},
	[TOGGLE_REGISTER]: state => {
		return { ...state, shouldRegister: true};
	},
	[LOGIN_USER_SUCCESS]: (state, actions) => initialState,
	[LOGOUT_USER_SUCCESS]: (state, actions) => initialState,
	[REGISTER_SUCCESS]: () => initialState,
	[REFETCH_ALL_DATA]: (state, actions) => {
		return {
			...state,
			userData: null,
			lists: null
		};
	},
	[SPINNER_TOGGLE]: state => ({
		...state,
		shouldShowLoadingSpinner: !state.shouldShowLoadingSpinner
	}),
	[CLOSE_POPUP]: state => ({
		...state,
		popup: null
	})
}, cloneDeep(initialState));

// selectors
export const selectors = {
	getUserData: state => state.app.userData,
	getAppConfig: state => state.app.config,
	getShouldLogin: state => state.app.shouldLogin,
	getShouldRegister: state => state.app.shouldRegister,
	getShouldShowLoadingSpinner: state => state.app.shouldShowLoadingSpinner,
	getIntl: state => intl(state),
	getPopup: state => state.app.popup,
	getContestConfig: state => state.app.userData.contestConfig,
	getLists: state => state.app.lists,
	getError: state => state.app.error
};

// functions
const getActiveBalance = ({ id }, balances) => {
	const storedCurrency = window.localStorage.getItem('activeBalance');

	if (!isRocket) {
		const activeCurrency = JSON.parse(storedCurrency);
		if (activeCurrency && activeCurrency['currency']) {
			return activeCurrency['currency'];
		}
		return 'usd';
	}

	try {
		const storedCurrencyObject = JSON.parse(storedCurrency);
		if (!storedCurrencyObject || storedCurrencyObject.userId !== id) {
			throw new Error('not that user');
		}
		return storedCurrencyObject['currency'];
	} catch (err) {
		let sortedBalances = sortBy(balances, row => {
			let amount = parseFloat(row.amount);
			if (amount) {
				return -amount;
			}
			return -parseFloat(row.hold_amount);
		});
		if (sortedBalances.length) {
			window.localStorage.setItem('activeBalance', JSON.stringify({userId: id, currency: sortedBalances[0].currency}));
			return sortedBalances[0].currency;
		}
	}
};

const popup = {
	shouldBeShown: () => {
		const date = localStorage.getItem('last_date_of_showing_popup');
		return !date || !moment(date).isSame(moment(), 'day');
	},
	updateLastShowDate: () => {
		localStorage.setItem('last_date_of_showing_popup', moment().toISOString());
	}
};

function omitQueryParams(link, params) {
	var parts = link.split('?');

	if (parts[1]) {
		var query = parts[1]
			.split('&')
			.filter(function (s) {
				return !params.some(function (param) {
					return s === param || !s.indexOf(param + '=');
				});
			})
			.join('&');

		return parts[0] + (query ? '?' + query : '');
	}

	return parts[0];
}



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/index.js